import { Button, Text, useIntl } from 'platform-components';
import React from 'react';

import './lessons-page__banner.scss';

export const SpecCourseLessonsPageBanner = () => {
    const intl = useIntl();

    const backgroundUrlId = 'specCourse.banner.backgroundSrc';
    const backgroundSrc = intl.formatMessage({ id: backgroundUrlId });

    const shouldShowImg = backgroundSrc !== backgroundUrlId;

    const style = {
        backgroundImage: shouldShowImg ? `url(${backgroundSrc})` : undefined,
    };

    return (
        <div className="spec-course-lessons-page__banner" style={style}>
            <div className="spec-course-lessons-page__banner-date">
                <Text id="specCourse.banner.date" size={Text.SIZE.XS} weight={Text.WEIGHT.L} />
            </div>
            <div className="spec-course-lessons-page__banner-title">
                <Text id="specCourse.banner.title" size={Text.SIZE.XXXL} />
            </div>
            <div className="spec-course-lessons-page__banner-description">
                <Text id="specCourse.banner.description" size={Text.SIZE.XL} weight={Text.WEIGHT.L} />
            </div>
            <div className="spec-course-lessons-page__banner-status">
                <div className="spec-course-lessons-page__banner-status-button">
                    <Button disabled size={Button.SIZE.L}>
                        <Text id="specCourse.banner.status.button" size={Text.SIZE.L} weight={Text.WEIGHT.L} />
                    </Button>
                </div>
                <div className="spec-course-lessons-page__banner-status-description">
                    <Text id="specCourse.banner.status.description" size={Text.SIZE.L} weight={Text.WEIGHT.L} />
                </div>
            </div>
        </div>
    );
};
